/* eslint-disable import/no-default-export */
export default {
  'ClearIconButton.title': 'Clear',
  'CloseButton.title': 'Close',
  'DuoChatContextItemPopover.DisabledReason': 'This item is disabled',
  'DuoChatContextItemTypeLabel.File': 'Project file',
  'DuoChatContextItemTypeLabel.GitCommit': 'Local Git repository commit',
  'DuoChatContextItemTypeLabel.GitDefault': 'Local Git repository',
  'DuoChatContextItemTypeLabel.GitDiff': 'Local Git repository diff',
  'DuoChatContextItemTypeLabel.Issue': 'Issue',
  'DuoChatContextItemTypeLabel.MergeRequest': 'Merge request',
  'GlAlert.closeButtonTitle': 'Dismiss',
  'GlBanner.closeButtonTitle': 'Dismiss',
  'GlBreadcrumb.showMoreLabel': 'Show more breadcrumbs',
  'GlBroadcastMessage.closeButtonTitle': 'Dismiss',
  'GlCollapsibleListbox.srOnlyResultsLabel': null,
  'GlDatepicker.monthLabel': 'Month',
  'GlDatepicker.yearLabel': 'Year',
  'GlDuoChat.chatCancelLabel': 'Cancel',
  'GlDuoChat.chatCloseLabel': 'Close the Code Explanation',
  'GlDuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'GlDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'GlDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'GlDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'GlDuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'GlDuoChat.chatEmptyStateDesc': 'GitLab Duo Chat is your AI-powered assistant.',
  'GlDuoChat.chatEmptyStateSecondaryDesc': 'Responses may be inaccurate. Verify before use.',
  'GlDuoChat.chatEmptyStateTitle': 'Ask a question',
  'GlDuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Chat',
  'GlDuoChat.chatPromptPlaceholderWithCommands': 'Type "/" for slash commands',
  'GlDuoChat.chatSubmitLabel': 'Send chat message.',
  'GlDuoChatContextItemDetailsModal.title': 'Preview',
  'GlDuoChatContextItemMenu.emptyStateMessage': 'No results found',
  'GlDuoChatContextItemMenu.loadingMessage': 'Loading...',
  'GlDuoChatContextItemMenu.searchInputPlaceholder': 'Search %{categoryLabel}...',
  'GlDuoChatContextItemMenu.selectedContextItemsTitle': 'Included references',
  'GlDuoChatConversation.newChat': 'New chat',
  'GlDuoChatLoader.gitlabDuo': 'GitLab Duo',
  'GlDuoChatLoader.loaderLoadingMessage': '%{tool} is %{transition} an answer',
  'GlDuoChatLoader.loaderLoadingTransitionsFinding': 'finding',
  'GlDuoChatLoader.loaderLoadingTransitionsGenerating': 'generating',
  'GlDuoChatLoader.loaderLoadingTransitionsProducing': 'producing',
  'GlDuoChatLoader.loaderLoadingTransitionsWorkingOn': 'working on',
  'GlDuoChatMessage.SelectedContextItemsTitleAssistantMessage': null,
  'GlDuoChatMessage.SelectedContextItemsTitleUserMessage': null,
  'GlDuoChatMessage.modalAlertText':
    'GitLab team members cannot view your conversation. Please be as descriptive as possible.',
  'GlDuoChatMessage.modalBetterResponse': 'How the response might better meet your needs.',
  'GlDuoChatMessage.modalDidWhat': 'What were you doing?',
  'GlDuoChatMessage.modalImproveWhat': 'How could the response be improved?',
  'GlDuoChatMessage.modalInteraction':
    'The situation in which you interacted with GitLab Duo Chat.',
  'GlDuoChatMessage.modalMessageError': 'Error sending the message',
  'GlDuoChatMessage.modalTitle': 'Give feedback on GitLab Duo Chat',
  'GlDuoChatMessageSources.messageSources': null,
  'GlDuoWorkflowPanel.collapseButtonTitle': 'Collapse',
  'GlDuoWorkflowPanel.expandButtonTitle': 'Expand',
  'GlDuoWorkflowPrompt.cancelButtonText': 'Cancel',
  'GlDuoWorkflowPrompt.confirmButtonText': 'Generate plan',
  'GlDuoWorkflowPrompt.imageDescription':
    'It should have any tools necessary for the workflow installed.',
  'GlDuoWorkflowPrompt.imageLabel': 'Image',
  'GlDuoWorkflowPrompt.imageLabelDescription': 'The container image to run the workflow in.',
  'GlDuoWorkflowPrompt.promptDescription': 'Be specific and include any requirements.',
  'GlDuoWorkflowPrompt.promptLabel': 'Description',
  'GlDuoWorkflowPrompt.promptLabelDescription': 'What would you like to do and how.',
  'GlDuoWorkflowPrompt.title': 'Goal',
  'GlKeysetPagination.navigationLabel': 'Pagination',
  'GlKeysetPagination.nextText': 'Next',
  'GlKeysetPagination.prevText': 'Previous',
  'GlModal.closeButtonTitle': 'Close',
  'GlPagination.labelFirstPage': 'Go to first page',
  'GlPagination.labelLastPage': 'Go to last page',
  'GlPagination.labelNextPage': 'Go to next page',
  'GlPagination.labelPage': 'Go to page %{page}',
  'GlPagination.labelPrevPage': 'Go to previous page',
  'GlPagination.nav': 'Pagination',
  'GlPagination.nextText': 'Next',
  'GlPagination.prevText': 'Previous',
  'GlSearchBoxByType.clearButtonTitle': 'Clear',
  'GlSearchBoxByType.input.placeholder': 'Search',
  'GlSorting.sortAscending': 'Sort direction: ascending',
  'GlSorting.sortDescending': 'Sort direction: descending',
  'GlToken.closeButtonTitle': 'Remove',
};
